import { cn } from "@omni/utils/styles";
import { components, GroupBase, MenuListProps } from "react-select";

export const MenuListComponent = <TOption, IsMulti extends boolean>(
    props: MenuListProps<TOption, IsMulti, GroupBase<TOption>>
) => {
    return (
        <components.MenuList
            {...props}
            className={cn(props.className, "tw:py-0!")}
        />
    );
};
